import { writable } from "svelte/store";

// 라이트/다크 테마 스토어. <html>.dark 토글 + localStorage 영속.
// 토큰(--sb-*)이 .dark에서 재정의되므로 컴포넌트별 dark: 분기 없이 전체가 전환된다.
const KEY = "sb-theme";

function readInitial() {
	if (typeof localStorage === "undefined") return "light";
	const saved = localStorage.getItem(KEY);
	if (saved === "light" || saved === "dark") return saved;
	return "light";
}

function apply(t) {
	if (typeof document === "undefined") return;
	document.documentElement.classList.toggle("dark", t === "dark");
}

export const theme = writable(readInitial());

// 구독 즉시 실행 → import 시점에 저장된 테마 적용
theme.subscribe((t) => {
	if (typeof localStorage !== "undefined") localStorage.setItem(KEY, t);
	apply(t);
});

export function toggleTheme() {
	theme.update((t) => (t === "dark" ? "light" : "dark"));
}
